import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { Singleton } from '../../js/Singleton';
import { setCookie, getCookie } from '../../js/cookies';
import { CURRENT_LANGUAGE } from '../../constants';
import { SingletonSharedData } from '../../js/singletonSharedData';

let instance = null;

export class helperLanguage {
  constructor(){
    if(!instance){
      instance = this;
      const APIFact = new APIFactory();
      this.apiCont = APIFact.buildClient();
      this.lagSingleton = new Singleton();
      this.sharedData = new SingletonSharedData();
    }
    return instance;
  }

  setLanguage(lang, languageObject){
    var currLang = '';
    if(lang === ''){//GET THE LANGUAGE FROM COOKIE
      currLang = getCookie(CURRENT_LANGUAGE);//GET THE COOKIE LANGUAGE
      if (currLang !== "") {//SET THE CURRENT LANGUAGE TO THE SINGLETON
        this.lagSingleton.setLanguage(currLang);
      }
    }else{//SET THE LANGUAGE PASSED
      currLang = lang;
      setCookie(CURRENT_LANGUAGE, lang);
      this.lagSingleton.setLanguage(currLang);
    }
    this.getTags(currLang, languageObject);
  }


  getTags(currLang, languageObject){
    const objectResponse = this.apiCont.getObjectResponse();
    this.apiCont.getLanguage(currLang, objectResponse);
    const _this = this;
    objectResponse.onSuccess = function(objResponse){
      _this.lagSingleton.setJsonLanguage(objResponse);
      _this.sharedData.setSoftPhone(parseInt(objResponse.Response[3].softphone, 10));
      _this.sharedData.setIntegrationConfiguration(objResponse.Response[3].integrationConnection);
      _this.sharedData.setVersionAgent(objResponse.Response[3].version);
      _this.sharedData.setCountry(objResponse.Response[3].idPais);
      _this.sharedData.setIPfromAPI(objResponse.Response[4].Value);
      _this.sharedData.setIPAddress(objResponse.Response[4].Value);
      languageObject();    
    };
    objectResponse.onError = function(messageError){
      console.error( messageError );
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/helpers/helperLanguage.js